import { atom } from "jotai"

export const userAtom = atom()
export const priceRangeAtom = atom({ min: 0, max: 10000 })
export const yearRangeAtom = atom({ min: 2010, max: 2024 })
export const showMessageBoxAtom = atom(false)
export const showIndividualMessageBoxAtom = atom(false)
export const recipientIdAtom = atom(null)
export const showCreateCategoryModalAtom = atom(false)
export const showManageCategoryModalAtom = atom(false)
export const showManageUserModalAtom = atom(false)
export const showCreateBoxTypeModalAtom = atom(false)
export const showManageBoxTypeModalAtom = atom(false)
export const showCreateConditionModalAtom = atom(false)
export const showManageConditionModalAtom = atom(false)
export const showCartAtom = atom(false)
export const cartListAtom = atom([])
